import { render } from "./DocumentSearchMask.vue?vue&type=template&id=c4366c5a&scoped=true&ts=true"
import script from "./DocumentSearchMask.vue?vue&type=script&lang=ts"
export * from "./DocumentSearchMask.vue?vue&type=script&lang=ts"

import "./DocumentSearchMask.vue?vue&type=style&index=0&id=c4366c5a&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4366c5a"]])

export default __exports__